import { apiV2 } from '../utils';
import { observable, computed } from 'mobx';
import { stateContext } from '../hooks/useStore';

type CategoriaNFeData = {
  categoria_financeira: number;
  ncm: string;
  cfop: number;
  cofins: string;
  cofins_cst: string;
  pis: string;
  pis_cst: string;
  unidade_medida: string;
  descricao_fiscal: string;
  codigo_produto: string;
  icms_nota: boolean;
  informacao_complementar?: string;
  inserir_especie?: boolean;
  incluir_nome_especie?: boolean;
  cfops: {
    cfop_id: number;
    padrao: boolean;
  }[];
  ativo: boolean;
};

class CategoriasNFe {
  @observable arr: CategoriaNFe[] | null = null;
  @computed
  get length(): number {
    return this.arr ? this.arr.length : 0;
  }

  async populate(): Promise<void> {
    const store = stateContext.state;
    const response = await apiV2.get('/categoria-nfe/', {
      params: {
        prop: store.propriedade?.id,
      },
    });
    this.arr = response.data.results || response.data || [];
  }

  async getEverything(params?: object): Promise<CategoriaNFe[]> {
    const store = stateContext.state;
    const response = await apiV2.get('/categoria-nfe/', {
      params: {
        prop: store.propriedade?.id,
        ...params,
      },
    });
    return response.data.results || response.data || [];
  }

  getByUuid(uuid: string): CategoriaNFe | undefined {
    return this.arr!.find((item) => item.uuid === uuid);
  }

  async criar(dados: CategoriaNFeData): Promise<void> {
    const store = stateContext.state;

    await apiV2
      .post('/categoria-nfe/', dados, {
        params: {
          prop: store.propriedade!.id,
        },
      })
      .then(async () => {
        store.notificar('Categoria NFe cadastrada com sucesso!');
        await this.populate();
      })
      .catch((error) => {
        console.log(error.response.data)
        const msg =
          error?.response?.data?.detail ||
          error?.response?.data?.erro ||
          (typeof error?.response?.data === 'string' ? error.response.data.erro : 'Ocorreu um erro ao cadastrar a categoria NFe!');
        store.notificar(msg);
      });
  }

  async editar(uuid: string, dados: CategoriaNFeData): Promise<void> {
    const store = stateContext.state;

    await apiV2
      .put(`/categoria-nfe/${uuid}/`, dados)
      .then(async () => {
        store.notificar('Categoria NFe editada com sucesso!');
        await this.populate();
      })
      .catch((error) => {
        const msg =
          error?.response?.data?.detail ||
          error?.response?.data?.error ||
          (typeof error?.response?.data === 'string' ? error.response.data : 'Ocorreu um erro ao editar a categoria NFe!');
        store.notificar(msg);
      });
  }

  async excluir(uuid: string): Promise<void> {
    const store = stateContext.state;

    await apiV2
      .delete(`/categoria-nfe/${uuid}/`, {
        params: {
          prop: store.propriedade!.id,
        },
      })
      .then(() => store.notificar('Categoria NFe excluída com sucesso!'));
    await this.populate();
  }

  filter(callback: (item: CategoriaNFe, index: number, array: CategoriaNFe[]) => void): CategoriaNFe[] {
    return this.arr!.filter(callback);
  }

  map(callback: (item: CategoriaNFe, index: number, array: CategoriaNFe[]) => any): any {
    return this.arr!.map(callback);
  }
}

export default CategoriasNFe;

